module.exports = __webpack_public_path__ + "static/media/vegitables_22.a334f1b0.csv";


//////////////////
// WEBPACK FOOTER
// ./src/data/vegitables/vegitables_22.csv
// module id = 605
// module chunks = 0